const utils = require('frontend-controller/lib/utils')

module.exports = {
	model: {
		bulkContentBaseFilters: {}
	},

	methods: {
		onBuild: function(storage){
			if(storage.isClient){
				this.model.bulkContentBaseFilters = this.getResourceRegisterContent('bulkContentBaseFilters') || {}
			}
		},

		moveToStart: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData) {
			const baseData = this.getMoveBaseData()
			baseData.type = 'moveToStart'
			if(baseData.sectionID){
				this.move(baseData)
			}
		},
		moveToBefore: function(){
			const row = this.getContentTableSelection();
			const componentAttributes = ((row || {}).rowData || {}).attributes || {}
			if(componentAttributes.sectionComponentID){
				const baseData = this.getMoveBaseData()
				baseData.type 				= 'moveToBefore'
				baseData.sort 				= componentAttributes.sort
				baseData.sectionComponentID = componentAttributes.sectionComponentID
				if(baseData.sectionID){
					this.move(baseData)
				}
			} else {
				// show invalid operation message
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:moveTo.sectionComponent.before.missingSectionComponentSelection'
						}
					})
				);
			}
		},
		moveToAfter: function(){
			const row = this.getContentTableSelection();
			const componentAttributes = ((row || {}).rowData || {}).attributes || {}
			if(componentAttributes.sectionComponentID){
				const baseData = this.getMoveBaseData()
				baseData.type 				= 'moveToAfter'
				baseData.sort 				= componentAttributes.sort
				baseData.sectionComponentID = componentAttributes.sectionComponentID
				if(baseData.sectionID){
					this.move(baseData)
				}
			} else {
				// show invalid operation message
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:moveTo.sectionComponent.after.missingSectionComponentSelection'
						}
					})
				);
			}
		},
		moveToEnd: function(){
			const baseData = this.getMoveBaseData()
			baseData.type = 'moveToEnd'
			if(baseData.sectionID){
				this.move(baseData)
			}
		},

		getContentTableSelection: function(){
			let result = false
			this.find('templates_bulk_contentTable', function(table){
				let rowIDs = table.getSelectedRowIDs(true)
				if(!utils.isArray(rowIDs)) rowIDs = Object.values(rowIDs)
				const rowID = rowIDs[0];
				if(rowID){
					const rowData = table.getRowData(rowID)
					if(rowData){
						result = {
							rowID,
							rowData
						}
					}
				}
			})
			return result
		},

		getMoveBaseData: function(){
			const base = this.model.bulkContentBaseFilters || {}
			const sectionID = base.sectionID || 0
			const parentSectionComponentID = base.parentSectionComponentID || 0
			return {
				sectionID,
				parentSectionComponentID,
			}
		},

		move: function(moveData){
			this.triggerClosest('onDecision', {
				decisionType: 'moveTargetSelected',
				decisionComponent: this,
				targetData: moveData
			})
		}
	},

	hooks: {
		showEdit: function($element, options){
			let searchTerm = ''
			if(options.id){
				searchTerm = `#${options.id}`
			}
			this.triggerFind('forceBySearchTerm', { searchTerm }, 'templates_bulk_filter')
			this.triggerFind('showEdit', options, 'templates_bulk_contentTable')
		},

		onDelete: function($element, options){
			var self = this
			self.triggerFind('onDelete', options, 'templates_bulk_contentTable')
		},

		forceBySearchTerm: function($element, options){
			this.triggerFind('forceBySearchTerm', options, 'templates_bulk_filter')
		}
	}
}